import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";

import isOnline from "is-online";

import {
  genderOptions,
  contactTypeOptions,
  allContactTypeOptions,
  contactTypes,
  entityTypes,
  entityTypeOptions,
} from "@/constants/person.js";
import { rulesOptions } from "@/constants/majority.js";
import { mandatePresenceStatuses, correspondenceTypes } from "@/constants/mandate.js";
import { meetingResolutionStatuses } from "@/constants/meeting-resolution.js";
import { meetingStatuses } from "@/constants/meeting.js";
import { voteTypes } from "@/constants/vote.js";

export default {
  data() {
    return {
      /** NOTE: constants used in multiple files */
      genderOptions,
      contactTypeOptions,
      allContactTypeOptions,
      contactTypes,
      entityTypeOptions,
      entityTypes,
      rulesOptions,
      mandatePresenceStatuses,
      correspondenceTypes,
      meetingResolutionStatuses,
      meetingStatuses,
      voteTypes,
    };
  },
  computed: {
    appId() {
      return localStorage.getItem("appId") ? Number(localStorage.getItem("appId")) : null;
    },
    agencyId() {
      return localStorage.getItem("agencyId") ? Number(localStorage.getItem("agencyId")) : null;
    },
    networkStatus() {
      return this.$store.state.isConnected;
    },
    mercureJwtToken() {
      return this.$store.getters["auth/mercureJwtToken"];
    },
    isAuthenticatedForMercure() {
      return this.$store.getters["auth/isAuthenticatedForMercure"];
    },
    isAuthenticated() {
      var isAuthenticated = this.$store.getters["auth/isAuthenticated"];
      if (!isAuthenticated) {
        localStorage.clear();
      }
      return isAuthenticated;
    },
    isDesktop() {
      return !process.env.VUE_APP_IS_WEB;
    },

    /** sync indicators variables */
    showSyncLoading() {
      return this.$store.state.showSyncLoading;
    },
    showSyncLoadingSuccess() {
      return this.$store.state.showSyncLoadingSuccess;
    },
    showSyncLoadingError() {
      return this.$store.state.showSyncLoadingError;
    },
  },
  methods: {
    getPercent(percent) {
      if (isNaN(percent)) {
        return 0;
      }
      if (percent == Infinity) {
        return 0;
      }
      if (percent == null) {
        return 0;
      }
      var percentProcessed = this.formatNumber(percent);
      return percentProcessed ? percentProcessed : 0;
    },
    formatNumber(nb) {
      return nb % 1 !== 0 ? parseFloat(nb.toFixed(2)) : nb;
    },

    showBr(string) {
      if (string == null) {
        return "";
      }
      return string.replace(/(\r\n|\n|\r)/gm, "<br>");
    },
    toLocalTime(timeString) {
      this.$moment.locale("fr");
      var localTime = this.$moment.utc(timeString).toDate();
      localTime = this.$moment(localTime).format("YYYY-MM-DD HH:mm:ss");
      return localTime;
    },

    // ???: ??
    // async checkConnection() {
    //   var x = await isOnline();
    //   this.$store.state.isConnected = x;
    //   // console.log(this.$store.state.isConnected);
    //   return x;
    // },

    // NOTE: vue-simple-alert functions
    alertError(title = this.$t("general.ERROR"), text = "", timer = 1500) {
      return {
        icon: "error",
        title: title,
        text: text,
        timer: timer,
        showConfirmButton: false,
      };
    },
    alertSuccess(title, text, timer = 1500) {
      return {
        icon: "success",
        title: title ? title : this.$t("general.SUCCESS"), // FIXME: ..
        text: text ? text : "",
        timer: timer,
        showConfirmButton: false,
      };
    },
    alertQuestion(title, text, confirmText = false, cancelText = false) {
      return {
        info: "question",
        title: title ? title : this.$t("general.Are_you_sure"), // FIXME: ..
        text: text ? text : "",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: confirmText ? confirmText : this.$t("general.Yes"),
        cancelButtonText: cancelText ? cancelText : this.$t("general.No"),
        // Configs ..
        reverseButtons: true, // invert default buttons positions ("Confirm"-button on the right side)
        buttonsStyling: false, // use your own classes (e.g. Bootstrap classes)
        confirmButtonClass: "btn btn-primary btn-lg",
        cancelButtonClass: "btn btn-light btn-lg",
      };
    },
    alertWarning(title, text) {
      return {
        icon: "warning",
        title: title ? title : "ATTENTION",
        text: text ? text : "",
        showConfirmButton: true,
        confirmButtonText: "OK",
        buttonsStyling: false, // use your own classes (e.g. Bootstrap classes)
        confirmButtonClass: "btn btn-warning btn-lg",
      };
    },

    // NOTE: position steps tunnel texts
    setStepTextsStyles() {
      const stepTexts = document.getElementsByClassName("step-text");
      for (const stepText of stepTexts) {
        let el = stepText;

        const textWidth = el.scrollWidth;
        const textHeight = el.scrollHeight;
        const buttonWidth = el.nextElementSibling.scrollWidth;

        let calcMiddle = textWidth / 2 - buttonWidth / 2;

        el.style.top = "-" + textHeight + "px";
        el.style.left = "-" + calcMiddle + "px";
      }
    },

    checkIfMandateIsAbsent(mandate) {
      try {
        // ???: can create confusion: null, invalid_correspondence & pouvoir_by_video_not_present_yet presence statuses are considered as absent
        return (
          mandate.presence_status == null ||
          mandate.presence_status == this.mandatePresenceStatuses.not_present ||
          mandate.presence_status == this.mandatePresenceStatuses.invalid_correspondence ||
          mandate.presence_status == this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet
        );
      } catch {
        return false;
      }
    },

    prepareBulkVotePostObj(voteType, mandates, meetingResolutionId) {
      var mandatesIds = [];
      mandates.forEach(mandate => {
        mandatesIds.push(mandate.id);
      });
      return {
        mandates_ids: mandatesIds,
        meeting_resolution_id: meetingResolutionId,
        vote_type: voteType,
      };
    },

    async deleteVotesByCorrespondenceForResolutionsThatWereNotVoted(mandate) {
      try {
        var ResolutionVoteMW = require("@/middlewares/ResolutionVote").default;
        // get All Votes for this mandate
        await ResolutionVoteMW.FETCH_BY_MANDATE(mandate.id);
        var MandateResolutionVotes = ResolutionVoteORM.query()
          .where("mandate_id", mandate.id)
          .where("presence_status", this.mandatePresenceStatuses.correspondence)
          .with("meeting_resolution")
          .get();

        var votesToDelete = this.$_.filter(MandateResolutionVotes, rv => {
          return rv.meeting_resolution && rv.meeting_resolution.status == null;
        });
        if (votesToDelete.length > 0) {
          await ResolutionVoteMW.BULK_DELETE(votesToDelete).catch(err => {
            console.error(err);
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
